import { AdminSettings } from '@unistocks/features/admin/components/settings/admin-settings';
import { t } from '@unistocks/shared/localization/index.ts';
import Head from 'expo-router/head';

export default function SettingManagementScreen() {
  return (
    <>
      <Head>
        <title>{t('AbpSettingManagement::Settings')}</title>
      </Head>
      <AdminSettings />
    </>
  );
}
